﻿import $ from 'jquery'
import ko from 'knockout';
import { IBinder, IBehaviorBinding, ICellBinding , IExternalElementBinder, ISubscribeFunction, IBehaviorFunction} from "./ibinder"
import { JsonBuilder } from "../jsonbuilder"

export class ExternalTrackChangesHideBinder implements IExternalElementBinder {
  key: string = "ExternalTrackChanges";
  initialTableData: string;
  $table: JQuery

  constructor(private tableKey: string) {
    this.$table = $("[data-et-key='" + this.tableKey + "']");
  }

  getElements(): JQuery {
    return $("[data-et-track-changes='" + this.tableKey + "']");
  }

  initialized(): boolean {
    if (this.$table.data("rustig.editortable"))
      return true;
    return false;
  }

  public compute(tableData): Function {
    if (!this.initialTableData)
      this.initialTableData = JsonBuilder.toJSON(tableData);
    return ko.computed(() => {
      return JsonBuilder.toJSON(tableData);
    });
  }

  public subscribe: ISubscribeFunction = (value) => {
    var $elements = this.getElements();
    var isDirty = this.initialized() && value != this.initialTableData;

    $elements.each(function () {
      if (isDirty)
        $(this).slideDown(100);
      else
        $(this).slideUp(100);
    });

  }
  public extend(): IBehaviorFunction {
    return null;
  }
}
